<app-header></app-header>
<app-toolbar></app-toolbar>
<app-submenu [items]="subMenuItems"></app-submenu>
<p-toast></p-toast>
<div class="cash-close grid grid-cols-10">

  <div class="col-span-4 border-r-2 border-black pb-20">
    <div *ngIf="office"
      class="text-2xl font-bold text-[#27368A] justify-center align-middle border-b-2 border-black pl-7 p-4">
      {{ office.cashier_status === 0 ? 'Abrir caja': 'Cierre de caja'}}
    </div>

    <div class="flex flex-row align-middle items-center pl-7 p-4 mb-3 gap-3">
      <p class="text-base font-bold text-[#27368A]">Recuento efectivo:</p>
      <p class="text-red-600 font-bold text-2xl"> {{ totalSum | currency:'EUR' }}</p>
    </div>

    <div class="grid grid-cols-2 ">

      <div class="grid justify-items-center">
        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-lg bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            2€</p>
          <input [(ngModel)]="coin_counter['2e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-lg bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            1€</p>
          <input [(ngModel)]="coin_counter['1e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-sm bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            50c</p>
          <input [(ngModel)]="coin_counter['50c']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-sm bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            20c</p>
          <input [(ngModel)]="coin_counter['20c']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-sm bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            10c</p>
          <input [(ngModel)]="coin_counter['10c']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-sm bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            5c</p>
          <input [(ngModel)]="coin_counter['5c']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-sm bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            2c</p>
          <input [(ngModel)]="coin_counter['2c']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p
            class="h-8 w-8 text-sm bg-[#D9D9D9] text-[#808080] rounded-full font-bold flex items-center justify-center">
            1c</p>
          <input [(ngModel)]="coin_counter['1c']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

      </div>

      <div>
        <div class="flex flex-row  gap-2 pb-3">
          <p class="h-8 w-14 text-lg bg-[#D9D9D9] text-[#808080]  font-bold flex items-center justify-center">500€</p>
          <input [(ngModel)]="coin_counter['500e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row  gap-2 pb-3">
          <p class="h-8 w-14 text-lg bg-[#D9D9D9] text-[#808080]  font-bold flex items-center justify-center">200€</p>
          <input [(ngModel)]="coin_counter['200e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p class="h-8 w-14 text-sm bg-[#D9D9D9] text-[#808080]  font-bold flex items-center justify-center">100€</p>
          <input [(ngModel)]="coin_counter['100e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p class="h-8 w-14 text-sm bg-[#D9D9D9] text-[#808080]  font-bold flex items-center justify-center">50€</p>
          <input [(ngModel)]="coin_counter['50e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p class="h-8 w-14 text-sm bg-[#D9D9D9] text-[#808080]  font-bold flex items-center justify-center">20€</p>
          <input [(ngModel)]="coin_counter['20e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p class="h-8 w-14 text-sm bg-[#D9D9D9] text-[#808080]  font-bold flex items-center justify-center">10€</p>
          <input [(ngModel)]="coin_counter['10e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>

        <div class="flex flex-row gap-2 pb-3">
          <p class="h-8 w-14 text-sm bg-[#D9D9D9] text-[#808080]  font-bold flex items-center justify-center">5€</p>
          <input [(ngModel)]="coin_counter['5e']" min="0" (ngModelChange)="calculateTotalSum()" type="number"
            class="h-8 w-14 pl-1 bg-[#EDEDED] border-2 border-black outline-none rounded-md">
        </div>


      </div>
    </div>
    <div [ngClass]="(office && office.cashier_status === 1)? '': 'hidden'" class="">
      <div class="p-3">


      </div>
    </div>
  </div>

  <div class="col-span-6 px-5 mb-5">
    <div class="flex flex-row items-center justify-between  mt-2">
      <p class="text-red-600 font-bold text-3xl">{{ today }}</p>
    </div>

    <div [ngClass]="(office && office.cashier_status === 1)? '': 'hidden'" style="display: none;"
      class="bg-[#EAEAEA] border-2 border-[#646363] my-3 pb-2">
      <table class="w-full text-left font-medium ">
        <thead>
          <tr class="border border-gray-300 px-4 py-1">
            <th class="text-2xl font-bold text-[#27368A] pl-2">Total día:</th>
            <th class="text-2xl font-bold text-[#27368A]">{{ cashRegister.totalN }}</th>
            <th class="text-2xl font-bold text-[#27368A]">{{ cashRegister.total.toFixed(2) | currency:'EUR' }} </th>
          </tr>
        </thead>
        <tbody>
          <tr class="">
            <th class="text-lg font-bold text-[#27368A] pl-4">Total ventas</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegister.totalIncomingN }}</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegister.totalIncoming.toFixed(2) | currency:'EUR' }}
            </th>
          </tr>
          <tr>
            <th class="pl-6">Efectivo</th>
            <th>{{ cashRegister.cashInflowN }}</th>
            <th>{{ cashRegister.cashInflowTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Tarjeta</th>
            <th>{{ cashRegister.cardIncomingTransactionsN }}</th>
            <th>{{ cashRegister.cardIncomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Bizum</th>
            <th>{{ cashRegister.bizumIncomingTransactionsN }}</th>
            <th>{{ cashRegister.bizumIncomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Transferencia</th>
            <th>{{ cashRegister.incomingTransfersN }}</th>
            <th>{{ cashRegister.incomingTransfersTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <ng-container *ngIf="office && (office?.id == 2 || office?.id == 3)">
            <tr>
              <th class="pl-6">Web</th>
              <th>{{ cashRegister.incomingWebN }}</th>
              <th>{{ cashRegister.incomingWebTotal.toFixed(2) | currency:'EUR' }} </th>
            </tr>
          </ng-container>
          <tr>
            <th class="text-lg font-bold text-[#27368A] pl-2">Total devoluciones</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegister.totalOutcomingN }}</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegister.totalOutcoming.toFixed(2) | currency:'EUR' }}
            </th>
          </tr>
          <tr>
            <th class="pl-6">Efectivo</th>
            <th>{{ cashRegister.cashOutflowN }}</th>
            <th>{{ cashRegister.cashOutflowTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>

          <tr>
            <th class="pl-6">Tarjeta</th>
            <th>{{ cashRegister.cardOutcomingTransactionsN }}</th>
            <th>{{ cashRegister.cardOutcomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Bizum</th>
            <th>{{ cashRegister.bizumOutcomingTransactionsN }}</th>
            <th>{{ cashRegister.bizumOutcomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr class="">
            <th class="pl-6">Transferencia</th>
            <th>{{ cashRegister.outcomingTransfersN }}</th>
            <th>{{ cashRegister.outcomingTransfersTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <ng-container *ngIf="office && (office?.id == 2 || office?.id == 3)">
            <tr>
              <th class="pl-6">Web</th>
              <th>{{ cashRegister.outcomingWebN }}</th>
              <th>{{ cashRegister.outcomingWebTotal.toFixed(2) | currency:'EUR' }} </th>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div [ngClass]="(office && office.cashier_status === 1)? '': 'hidden'"
      class="bg-[#EAEAEA] border-2 border-[#646363] my-3 pb-2">
      <table class="w-full text-left font-medium">
        <thead>
          <tr class="border border-gray-300 px-4 py-1">
            <th class="text-2xl font-bold text-[#27368A] pl-2">Total por turno:</th>
            <th class="text-2xl font-bold text-[#27368A]">{{ (cashRegisterByTurn.totalInWithoutCashierMovesN +
              cashRegisterByTurn.totalOutWithoutCashierMovesN) }}</th>
            <th class="text-2xl font-bold text-[#27368A]">{{ (cashRegisterByTurn.totalInWithoutCashierMoves +
              cashRegisterByTurn.totalOutWithoutCashierMoves).toFixed(2) | currency:'EUR' }} </th>
          </tr>
        </thead>
        <tbody>
          <tr class="">
            <th class="text-lg font-bold text-[#27368A] pl-4">Total turno entradas</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegisterByTurn.totalInWithoutCashierMovesN }}</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegisterByTurn.totalInWithoutCashierMoves.toFixed(2) |
              currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Efectivo</th>
            <th>{{ cashRegisterByTurn.cashInflowN }}</th>
            <th>{{ cashRegisterByTurn.cashInflowTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Tarjeta</th>
            <th>{{ cashRegisterByTurn.cardIncomingTransactionsN }}</th>
            <th>{{ cashRegisterByTurn.cardIncomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Bizum</th>
            <th>{{ cashRegisterByTurn.bizumIncomingTransactionsN }}</th>
            <th>{{ cashRegisterByTurn.bizumIncomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Transferencia</th>
            <th>{{ cashRegisterByTurn.incomingTransfersN }}</th>
            <th>{{ cashRegisterByTurn.incomingTransfersTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <ng-container *ngIf="office && (office?.id == 2 || office?.id == 3)">
            <tr>
              <th class="pl-6">Web</th>
              <th>{{ cashRegisterByTurn.incomingWebN }}</th>
              <th>{{ cashRegisterByTurn.incomingWebTotal.toFixed(2) | currency:'EUR' }} </th>
            </tr>
          </ng-container>
          <tr>
            <th class="text-lg font-bold text-[#27368A] pl-2">Total devoluciones</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegisterByTurn.totalOutWithoutCashierMovesN }}</th>
            <th class="text-lg font-bold text-[#27368A]">{{ cashRegisterByTurn.totalOutWithoutCashierMoves.toFixed(2) |
              currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Efectivo</th>
            <th>{{ cashRegisterByTurn.cashOutflowN }}</th>
            <th>{{ cashRegisterByTurn.cashOutflowTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>

          <tr>
            <th class="pl-6">Tarjeta</th>
            <th>{{ cashRegisterByTurn.cardOutcomingTransactionsN }}</th>
            <th>{{ cashRegisterByTurn.cardOutcomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr>
            <th class="pl-6">Bizum</th>
            <th>{{ cashRegisterByTurn.bizumOutcomingTransactionsN }}</th>
            <th>{{ cashRegisterByTurn.bizumOutcomingTransactionsTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <tr class="">
            <th class="pl-6">Transferencia</th>
            <th>{{ cashRegisterByTurn.outcomingTransfersN }}</th>
            <th>{{ cashRegisterByTurn.outcomingTransfersTotal.toFixed(2) | currency:'EUR' }} </th>
          </tr>
          <ng-container *ngIf="office && (office?.id == 2 || office?.id == 3)">
            <tr>
              <th class="pl-6">Web</th>
              <th>{{ cashRegisterByTurn.outcomingWebN }}</th>
              <th>{{ cashRegisterByTurn.outcomingWebTotal.toFixed(2) | currency:'EUR' }} </th>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div [ngClass]="(office && office.cashier_status === 1)? 'hidden': ''"
      class="h-[390px] bg-[#EAEAEA] border-2 border-[#646363] my-3">
    </div>
    <div class="grid place-items-end">
      <swal #confirmCashSwal title="Recordatorio" text="Recuerde realizar el recuento correctamente." icon="warning"
        [showCancelButton]="true" [focusCancel]="true" confirmButtonText="Aceptar" cancelButtonText="Cancelar" (confirm)="onAllowConfirmCash()"
        (willClose)="onCancelConfirmCash()">
      </swal>
      <ng-container *ngIf="office && office.cashier_status === 0">
        <button
          class="bg-green-600 justify-center items-center text-white text-xl font-bold rounded-xl h-10 w-60 sm:w-52"
          id="button-confirm" *ngIf="!allowOpenCash" [swal]="confirmCashSwal">Hacer recuento</button>
        <button
          class="bg-green-600 justify-center items-center text-white text-xl font-bold rounded-xl h-10 w-60 sm:w-52"
          id="button-confirm" *ngIf="allowOpenCash" (click)="confirmCash()">ABRIR CAJA</button>
      </ng-container>
      <ng-container *ngIf="office && office.cashier_status === 1">
        <button
          class="bg-red-600 justify-center items-center text-white text-xl font-bold rounded-xl h-10 w-60 sm:w-52 mb-1"
          (click)="handleCashCashier(false)">Salida de caja</button>
        <button class="bg-red-600 justify-center items-center text-white text-xl font-bold rounded-xl h-10 w-60 sm:w-52"
          id="button-confirm" *ngIf="!allowCloseCash" [swal]="confirmCashSwal">Hacer recuento</button>
        <button class="bg-red-600 justify-center items-center text-white text-xl font-bold rounded-xl h-10 w-60 sm:w-52"
          id="button-confirm" *ngIf="allowCloseCash" (click)="confirmCash()">CERRAR CAJA</button>
      </ng-container>
    </div>
  </div>
  <p-confirmDialog #cd [style]="{ width: '95%', maxWidth: '400px' }">
    <ng-template pTemplate="header">
      <h3 class="border-b border-gray-300 w-full pb-2 text-lg">Salida de caja en efectivo</h3>
    </ng-template>
    <ng-template pTemplate="icon">
      <!-- <i class="pi pi-user"></i> -->
    </ng-template>
    <ng-template pTemplate="message">
      <section class="flex justify-center w-full">
        <div>
          <p class="block ">Indique la cantidad</p>
          <input class="flex align-middle w-full bg-[#f0f0f0] px-3 py-2 rounded-[10px] h-10" appOnlyNumbersFloat
            appValidateZeroInput type="text" placeholder="Importe..." [(ngModel)]="cashOutAmount">
        </div>

      </section>
    </ng-template>
    <ng-template pTemplate="footer">
      <button class="bg-red-600 justify-center items-center text-white text-normal rounded-xl py-1 px-4 mr-1"
        type="button" pButton label="Cancelar" (click)="cd.reject()"></button>
      <button class="bg-green-600 justify-center items-center text-white text-normal rounded-xl py-1 px-4" type="button"
        pButton label="Aceptar" (click)="cd.accept()"></button>
    </ng-template>
  </p-confirmDialog>
  <p-toast></p-toast>
</div>
